import { Footer } from "../components/ui/footer";

export function Contact({baseUrl}) {
  return (
    <div>
    <div className="p-8">
      <h1 className="text-3xl font-bold">Contact Us</h1>
      <p className="mt-4">You can reach us at: contact@mystic.com</p>
    </div>
    <Footer baseUrl={baseUrl}/>
    </div>
  );
}